import { render } from "./DataParseCompForReqCat.vue?vue&type=template&id=77e009c2&scoped=true"
import script from "./DataParseCompForReqCat.vue?vue&type=script&lang=js"
export * from "./DataParseCompForReqCat.vue?vue&type=script&lang=js"

import "./DataParseCompForReqCat.vue?vue&type=style&index=0&id=77e009c2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e009c2"]])

export default __exports__